import { call, put, takeLatest } from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import * as constants from './constants';
import * as actions from './actions';

export function* getTags(action) {
  try {
    const params = {
      query: {
        limit: 10,
        name: action?.payload?.name ?? '',
      },
    };

    const { data } = yield call(request, API.BROWSE_TAGS_BY_NAME, 'GET', params);

    yield put(actions.getTagsSuccess(data));
  } catch (e) {
    yield put(actions.getTagsError(e));
  }
}

export function* getTagsWatcher() {
  yield takeLatest(constants.GET_TAGS, getTags);
}
